// src/utils/formatters.js
export const formatCurrency = (amount, currency = 'ZMW') => {
  return new Intl.NumberFormat('en-ZM', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatNumber = (number) => {
  return new Intl.NumberFormat('en-US').format(number);
};

export const formatPhone = (phone) => {
  // Format phone numbers for display
  if (!phone) return '';
  return phone.replace(/(\+\d{3})(\d{2})(\d{3})(\d{4})/, '$1 $2 $3 $4');
};

export const getCurrentDate = () => {
  return new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const getDateRange = (quickFilter) => {
  const now = new Date();
  const start = new Date();
  
  switch (quickFilter) {
    case 'Today':
      start.setHours(0, 0, 0, 0);
      return { start, end: now };
    case 'Weekly':
      start.setDate(now.getDate() - 7);
      return { start, end: now };
    case 'Monthly':
      start.setMonth(now.getMonth() - 1);
      return { start, end: now };
    case 'Yearly':
      start.setFullYear(now.getFullYear() - 1);
      return { start, end: now };
    default:
      return { start: null, end: null };
  }
};